/**
 * RESPONSIBILITY: one person — a name, what they do, and a photograph.
 *
 * Shared by the leadership team and a ministry's own team, because they are the same
 * three things and a second row type would only differ by where it is listed.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Img } from '@framework/core/decorators';

@Row()
export class Person {
  @Text({ label: 'Name', maxLength: 300 })
  name!: string;

  @Text({ label: 'Role', maxLength: 300, description: 'What they do. e.g. Worship lead.' })
  role!: string;

  @Img({
    label: 'Photo', folder: 'people', maxSizeMb: 12, size: '600 × 600',
    description: 'Their portrait. A square picture crops best.',
  })
  photo!: ImageValue;
}
